export const tabs = [
    "Friends",
    "Pending",
    "Incoming"
];

export const testFriends = [
    {
        id: 1,
        name: "Jason",
        username: "Jmomo12",
        points: 435,
    },
    {
        id: 2,
        name: "Joan",
        username: "ofarch5",
        points: 423111,
    },
    {
        id: 3,
        name: "Jason2",
        username: "Jmomo12",
        points: 435,
    },
    {
        id: 4,
        name: "Joan2",
        username: "ofarch5",
        points: 423111,
    },
    {
        id: 5,
        name: "Jason3",
        username: "Jmomo12",
        points: 435,
    },
    {
        id: 6,
        name: "Joan3",
        username: "ofarch5",
        points: 423111,
    },
    {
        id: 7,
        name: "Jason4",
        username: "Jmomo12",
        points: 435,
    },
    {
        id: 8,
        name: "Joan4",
        username: "ofarch5",
        points: 423111,
    },
    {
        id: 9,
        name: "Jason5",
        username: "Jmomo12",
        points: 435,
    },
    {
        id: 10,
        name: "Joan5",
        username: "ofarch5",
        points: 423111,
    },
    {
        id: 11,
        name: "Jason6",
        username: "Jmomo12",
        points: 435,
    },
    {
        id: 12,
        name: "Joan6",
        username: "ofarch5",
        points: 423111,
    },
    {
        id: 13,
        name: "Jason7",
        username: "Jmomo12",
        points: 435,
    },
    {
        id: 14,
        name: "Joan7",
        username: "ofarch5",
        points: 423111,
    },
    {
        id: 15,
        name: "Jason8",
        username: "Jmomo12",
        points: 435,
    },
    {
        id: 16,
        name: "Joan8",
        username: "ofarch5",
        points: 423111,
    },
];